import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-citizen-extern',
  templateUrl: './citizen-extern.component.html',
  styleUrls: ['./citizen-extern.component.scss'],
  standalone: false,
})
export class CitizenExternComponent implements AfterViewInit {
  constructor() {
    window.onresize = this.setContentHeight;
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    // this.setContentHeight();
    // }, 30);
  }

  setContentHeight() {
    const content = window.document.getElementById('content_container');
    const footer = window.document.getElementById('footer_container');
    const header = window.document.getElementById('header_container');

    if (content && footer && header) {
      content.style.height = window.document.documentElement.clientHeight - footer.clientHeight - header.clientHeight - 1 + 'px';
    }
  }
}
